import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { SlidersHorizontal, X } from "lucide-react";
import { ZONES, DURATIONS, FORMATS } from "../lib/skills";
import { useT } from "../lib/useLanguage";

const TYPES = [
  { key: "offer", label: { fr: "Offres", en: "Offers" } },
  { key: "request", label: { fr: "Demandes", en: "Requests" } },
  { key: "session", label: { fr: "Sessions", en: "Sessions" } },
];

const CATS = ["Langues", "Études", "Digital", "CV / Emploi", "Sport", "Créatif", "Vie pratique", "Projets"];

export default function FilterDrawer({ filters, onChange }) {
  const t = useT();
  const [open, setOpen] = useState(false);

  function toggle(key, value) {
    const arr = filters[key] || [];
    const next = arr.includes(value) ? arr.filter(x => x !== value) : [...arr, value];
    onChange({ ...filters, [key]: next });
  }

  function clearAll() { onChange({ types: [], categories: [], zones: [], formats: [], durations: [] }); }

  const activeCount = Object.values(filters).flat().length;

  function ChipGroup({ title, field, options }) {
    return (
      <div className="mb-5">
        <p className="text-xs font-semibold text-muted-foreground mb-2 uppercase tracking-wide">{title}</p>
        <div className="flex flex-wrap gap-2">
          {options.map(opt => {
            const val = typeof opt === "object" ? opt.key : opt;
            const label = typeof opt === "object" ? (opt.label.fr) : opt;
            const active = (filters[field] || []).includes(val);
            return (
              <button key={val} onClick={() => toggle(field, val)}
                className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${active ? "text-white border-transparent" : "bg-background border-border text-muted-foreground"}`}
                style={active ? { backgroundColor: "#FF6B4A", borderColor: "#FF6B4A" } : {}}>
                {label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="relative flex items-center gap-1.5 px-3 py-2 rounded-full border text-xs font-medium transition-all"
          style={{ borderColor: activeCount > 0 ? "#FF6B4A" : "#e5e7eb", color: activeCount > 0 ? "#FF6B4A" : "#6b7280" }}>
          <SlidersHorizontal className="h-3.5 w-3.5" />
          {activeCount > 0 ? `Filtres (${activeCount})` : "Filtres"}
        </button>
      </SheetTrigger>
      <SheetContent side="bottom" className="h-[80vh] overflow-y-auto rounded-t-2xl">
        <SheetHeader className="mb-4 flex-row items-center justify-between">
          <SheetTitle className="text-base font-bold">Filtres</SheetTitle>
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" className="text-xs" onClick={clearAll}>{t("filter_clear")}</Button>
            <Button size="sm" className="rounded-full text-xs" style={{ backgroundColor: "#FF6B4A" }} onClick={() => setOpen(false)}>
              {t("filter_apply")}
            </Button>
          </div>
        </SheetHeader>
        <ChipGroup title="Type" field="types" options={TYPES} />
        <ChipGroup title="Catégorie" field="categories" options={CATS} />
        <ChipGroup title="Zone" field="zones" options={ZONES.slice(0, 10)} />
        <ChipGroup title="Format" field="formats" options={FORMATS} />
        <ChipGroup title="Durée" field="durations" options={DURATIONS} />
      </SheetContent>
    </Sheet>
  );
}